import { ReactSVG } from "react-svg";
import { TenantBankAccount } from "services/api/tenants/types";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

/**
 * Kolone tablice bankovnih računa tenanta.
 * Bez `onDeleteClick` (pregled) izostaje kolona s akcijama.
 */
export const TENANT_BANK_ACCOUNT_COLUMNS = (
  onDeleteClick?: (event: React.MouseEvent<HTMLDivElement>, id: string) => void
): Column[] => [
  {
    title: "IBAN",
    field: "",
    type: ColumnTypes.custom,
    render: (row: TenantBankAccount) => (
      <div className="text-md font-medium text-slate-600">{row.iban}</div>
    ),
  },
  {
    title: "Primarni",
    field: "",
    type: ColumnTypes.custom,
    render: (row: TenantBankAccount) => (
      <div className="text-sm text-slate-900">{row.primary ? "Da" : "Ne"}</div>
    ),
  },
  {
    title: "Banka",
    field: "",
    type: ColumnTypes.custom,
    render: (row: TenantBankAccount) => (
      <div className="text-sm text-slate-900 truncate">{row.bankName ?? "-"}</div>
    ),
  },
  {
    title: "Opis",
    field: "",
    type: ColumnTypes.custom,
    render: (row: TenantBankAccount) => (
      <div className="text-sm text-slate-500 truncate">{row.description ?? "-"}</div>
    ),
  },
  ...(onDeleteClick
    ? [
        {
          title: "",
          field: "",
          type: ColumnTypes.custom,
          render: (row: TenantBankAccount) => (
            <div
              onClick={(e) => onDeleteClick(e, row.id)}
              className="flex justify-end items-center h-[30px] cursor-pointer"
            >
              <ReactSVG
                src={"/media/icons/trash.svg"}
                className="w-4 h-4 stroke-[#bd0000]"
              />
            </div>
          ),
        } as Column,
      ]
    : []),
];
